import { registerAction } from '../../Action'

const LOAD_PRESENTATION_CREATION_THEMES = 'LOAD_PRESENTATION_CREATION_THEMES'

const reducer = (state = {}, action) => ({
  ...state,
  presentationCreationThemes: action.payload,
})

const loadPresentationCreationThemes = registerAction(
  LOAD_PRESENTATION_CREATION_THEMES,
  { reducer }
)

export default loadPresentationCreationThemes
